// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeNotificationSettingsSetGameAlertBody = {
  eventId: string;
  alertKindKey: string;
  isEnabled: boolean;
};

export type typeNotificationSettingsSetGameAlertOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { eventId: string; alertKindKey: string; isEnabled: boolean };
};

export type typeNotificationSettingsSetGameAlertOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeNotificationSettingsSetGameAlertOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeNotificationSettingsSetGameAlertOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaNotificationSettingsSetGameAlertBody = {
  type: "object",
  properties: {
    eventId: { type: "string", maxLength: 3000, minLength: 1 },
    alertKindKey: { type: "string", maxLength: 3000, minLength: 1 },
    isEnabled: { type: "boolean" },
  },
  required: ["eventId", "alertKindKey", "isEnabled"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createNotificationSettingsSetGameAlert(
  options: SdkOptions,
) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaNotificationSettingsSetGameAlertBody);
  }

  return async function postNotificationSettingsSetGameAlert(
    payload: typeNotificationSettingsSetGameAlertBody,
  ): Promise<
    | typeNotificationSettingsSetGameAlertOutput200
    | typeNotificationSettingsSetGameAlertOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postNotificationSettingsSetGameAlert" failed before calling the network. #bf121165f099`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#bf121165f099" },
        },
        data: null,
      } as typeNotificationSettingsSetGameAlertOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/notification-settings/set-game-alert`,
      httpMethod: "POST",
      options,
    })) as
      | typeNotificationSettingsSetGameAlertOutput200
      | typeNotificationSettingsSetGameAlertOutput400;
  };
}
